// inspectionForm.schema.js
//
// Single source of truth for "FISA DE VERIFICARE MAGAZIN".
// Labels are transcribed verbatim from the printed sheet (no diacritics, uppercase as printed)
// so the screen and the PDF export match the paper form.
//
// Consumed by: LocationInspectionDetails.js, LocationInspectionFormPdfTemplate.js

export const INSPECTION_STATUSES = {
  DRAFT: "DRAFT",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
};

export const SECTIONS = [
  {
    key: "s1",
    no: "1",
    title: "MAGAZIN",
    max: 39,
    observationsKey: "observatii_s1",
    items: [
      {
        key: "scor_1_1",
        no: "1.1",
        weight: 5,
        label:
          "ASPECT GENERAL MAGAZIN (iluminatul este functional, afisele reclamele sunt in stare buna, nu sunt ingalbenite sau deteriorate)",
      },
      {
        key: "scor_1_2",
        no: "1.2",
        weight: 5,
        label:
          "ASPECT VITRINE MARFA (vitrinele sunt sterse si curate, produsele sunt expuse conform planogramei)",
      },
      { key: "scor_1_3", no: "1.3", weight: 5, label: "ACTE SI AFISE OBLIGATORII, CONFORM ANEXA" },
      { key: "scor_1_4", no: "1.4", weight: 5, label: "TOATE PRODUSELE AU PRETURI SI SE RESPECTA PLANOGRAMA" },
      {
        key: "scor_1_5",
        no: "1.5",
        weight: 5,
        label: "PRODUSELE AU ETICHETE CU INDICAREA PROVENIENTEI SI AU DESCRIERE IN LIMBA ROMANA",
      },
      {
        key: "scor_1_6",
        no: "1.6",
        weight: 4,
        label: "APARATELE SUNT CURATATE DE SPAN, MASA DE LUCRU ESTE CURATA SI ORDONATA",
      },
      {
        key: "scor_1_7",
        no: "1.7",
        weight: 5,
        label:
          "OPERATORUL POARTA ECUSON SI ARE TINUTA DECENTA DE LUCRU (haine curate, fara pantaloni scurti, tricouri taiate etc.)",
      },
      { key: "scor_1_8", no: "1.8", weight: 5, label: "MAGAZINUL ESTE CURAT SI ORDONAT, SERTARELE ORGANIZATE" },
    ],
  },
  {
    key: "s2",
    no: "2",
    title: "MARFA SI APTITUDINI OPERATOR",
    max: 24,
    observationsKey: "observatii_s2",
    items: [
      { key: "scor_2_1", no: "2.1", weight: 5, label: "MARFA ESTE ARANJATA PE CATEGORII CONFORM INDICATIILOR" },
      { key: "scor_2_2", no: "2.2", weight: 5, label: "APARATELE SUNT CURATE, FUNCTIONALE SI UPDATATE" },
      { key: "scor_2_3", no: "2.3", weight: 5, label: "SE RESPECTA PROCEDURILE DE LUCRU LA COPIEREA CHEILOR" },
      {
        key: "scor_2_4",
        no: "2.4",
        weight: 4,
        label:
          "Vazatorul din magazin este serviabil, saluta si multumeste la venirea si plecarea clientului, propune promotiile in vigoare, practica o vanzare activa.",
      },
      { key: "scor_2_5", no: "2.5", weight: 5, label: "NU EXISTA REBUTURI NEDECLARATE PE MAGAZIN (fara aviz)" },
    ],
  },
];

export const MAX_SCORE = 63;

export const CONCLUSION_KEYS = ["concluzii_1", "concluzii_2", "concluzii_3", "concluzii_4"];

export const EXTRA_OBSERVATION_KEYS = ["observatii_suplimentare_1", "observatii_suplimentare_2"];

export const ANEXA_GROUPS = [
  {
    key: "a",
    title: "1. ACTE SOCIETATE",
    secondColumn: "TERMEN DE VALABILITATE",
    rows: [
      { key: "anexa_a1", label: "CERTIFICATUL DE INMATRICULARE AL SOCIETATII COMERCIALE", secondType: "text" },
      { key: "anexa_a2", label: "CERTIFICATUL CONSTATATOR AL PUNCTULUI DE LUCRU", secondType: "text" },
      { key: "anexa_a3", label: "REGISTRUL UNIC DE CONTROL/STAMPILA", secondType: "text" },
      { key: "anexa_a4", label: "PLANUL DE EVACUARE IN CAZ DE INCENDIU", secondType: "text" },
      {
        key: "anexa_a5",
        label: "AUTORIZATIE DE FUNCTIONARE (SE VA INDICA TERMENUL DE REINNOIRE)",
        secondType: "date",
      },
      { key: "anexa_a6", label: "COPIE CONTRACTE INDIVIDUALE DE MUNCA OPERATORI PUNCT DE LUCRU", secondType: "text" },
      {
        key: "anexa_a7",
        label: "AUTORIZATIE PRAM (SE VA INDICA TERMENUL URMATOAREI VERIFICARI)",
        secondType: "date",
      },
      {
        key: "anexa_a8",
        label: "MANUAL CASA DE MARCAT ; DECLARATIE INSTALARE; REGISTRU SPECIAL; CARTE INTERVENTIE",
        secondType: "text",
      },
      { key: "anexa_a9", label: "REGISTRUL DE BANI PERSONALI", secondType: "text" },
      { key: "anexa_a10", label: "REGISTRUL DE SESIZARI SI RECLAMATII", secondType: "text" },
    ],
  },
  {
    key: "b",
    title: "2. AFISE OBLIGATORII",
    secondColumn: "MASURI",
    rows: [
      { key: "anexa_b1", label: "AFIS - LIMITELE DE ADAOS COMERCIAL PRACTICAT", secondType: "text" },
      {
        key: "anexa_b2",
        label: "AFIS PRIVIND OBLIGATIA CLIENTILOR DE A SOLICITA SI PASTRA BONUL FISCAL",
        secondType: "text",
      },
      {
        key: "anexa_b3",
        label: 'AFIS "UNITATE DOTATA CU CASA DE MARCAT FISCALA. VA RUGAM PASTRATI BONUL FISCAL !"',
        secondType: "text",
      },
      { key: "anexa_b4", label: "AFIS ANAF CU OBLIGATIE SOLICITARE SI ELIBERARE BON FISCAL", secondType: "text" },
      { key: "anexa_b5", label: "AFIS ANPC PRIVIND SOLUTIONAREA LITIGIILOR", secondType: "text" },
      { key: "anexa_b6", label: "AFIS TELEFONUL PENTRU OFICIUL DE PROTECTIE A CONSUMATORULUI", secondType: "text" },
      { key: "anexa_b7", label: "PROGRAM DE FUNCTIONARE + PROGRAM PAUZE DE MASA - AFISAT", secondType: "text" },
      { key: "anexa_b8", label: "LISTA PRETURI ACTUALIZATA - AFISATA", secondType: "text" },
    ],
  },
  {
    key: "c",
    title: "3. DOTARI",
    secondColumn: "TERMEN DE VALABILITATE",
    rows: [
      {
        key: "anexa_c1",
        label: "EXISTENTA EXTINCTOARE (SE VA INDICA TERMENUL URMATOAREI VERIFICARI)",
        secondType: "date",
      },
      { key: "anexa_c2", label: "TRUSA MEDICALA (SE VA INDICA TERMENUL DE EXPIRARE)", secondType: "date" },
    ],
  },
];

export const EXISTA_OPTIONS = [
  { value: "DA", label: "EXISTA" },
  { value: "NU", label: "NU EXISTA" },
];

export const GRADE_LEGEND = [
  { label: "foarte bine", range: "95-100%" },
  { label: "bine", range: "90-94.99%" },
  { label: "satisfacator", range: "85-89.99%" },
  { label: "nesatisfacator", range: "<85%" },
];

// Suffix used for the two Anexa cells of every checklist row.
export const anexaExistaKey = (rowKey) => `${rowKey}_exista`;
export const anexaObsKey = (rowKey) => `${rowKey}_obs`;

export const ALL_SCORE_ITEMS = SECTIONS.flatMap((section) => section.items);

export const ALL_ANEXA_ROWS = ANEXA_GROUPS.flatMap((group) => group.rows);

const toScore = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const getGrade = (percent) => {
  if (percent >= 95) return "Foarte Bine";
  if (percent >= 90) return "Bine";
  if (percent >= 85) return "Satisfacator";
  return "Nesatisfacator";
};

/**
 * Derived score summary. Never persisted - always recomputed from `fields`.
 */
export const computeTotals = (fields = {}) => {
  const sectionTotals = {};
  let total = 0;

  SECTIONS.forEach((section) => {
    const sum = section.items.reduce((acc, item) => acc + (toScore(fields[item.key]) ?? 0), 0);
    sectionTotals[section.key] = sum;
    total += sum;
  });

  const percent = MAX_SCORE > 0 ? (total / MAX_SCORE) * 100 : 0;

  return {
    sectionTotals,
    total,
    percent,
    percentLabel: percent.toFixed(2),
    grade: getGrade(percent),
  };
};

/**
 * A form is COMPLETED once every score and every Anexa answer is filled in and the
 * three identifying fields are set. Anything less is IN_PROGRESS.
 */
export const computeStatus = (fields = {}, { inspectionDate, operatorId, locationId } = {}) => {
  const allScoresFilled = ALL_SCORE_ITEMS.every((item) => toScore(fields[item.key]) !== null);
  const allAnexaAnswered = ALL_ANEXA_ROWS.every(
    (row) => String(fields[anexaExistaKey(row.key)] ?? "").trim().length > 0
  );
  const identified = Boolean(inspectionDate) && Boolean(operatorId) && Boolean(locationId);

  return allScoresFilled && allAnexaAnswered && identified
    ? INSPECTION_STATUSES.COMPLETED
    : INSPECTION_STATUSES.IN_PROGRESS;
};
